import React, { useEffect, useRef, useState } from "react";
import { ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle, Input, InputGroup } from "reactstrap";

interface Props {
    heading: string;
    listItems: any[];
    selectedIds: any[];
    setSelectedIds: (ids: any[]) => void;
}

const MinimalMultiSelect = ({ heading, listItems, selectedIds, setSelectedIds }: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleDropdown = () => setIsOpen(!isOpen);
    const handleSearch = (event: any) => setSearchTerm(event.target.value);
    const filteredList = listItems.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase()));
    
    const handleSelect = (id: any) => {
        setSelectedIds(selectedIds.includes(id) ? selectedIds.filter(i => i !== id) : [...selectedIds, id]);
    };

    return (
        <div ref={dropdownRef}>
            <ButtonDropdown isOpen={isOpen} toggle={toggleDropdown} style={{ width: '100%' }}>
            <DropdownToggle
                caret
                className="d-flex justify-content-between align-items-center"
                style={{
                    backgroundColor: 'white',
                    color: 'grey',
                    border: '1px solid #ced4da',
                    width: '100%',
                    textAlign: 'left'
                }}
            >
                <span>{heading}</span>
            </DropdownToggle>

                <DropdownMenu style={{ maxHeight: '40vh', overflowY: 'auto' }}>
                    {listItems.length > 0 ? (
                        <>
                            <InputGroup className="mb-2 px-2">
                                <Input type="text" placeholder="Search..." value={searchTerm} onChange={handleSearch} />
                            </InputGroup>
                            {filteredList.map(option => (
                                <DropdownItem key={option.id} onClick={() => handleSelect(option.id)}>
                                    <input type="checkbox" checked={selectedIds.includes(option.id)} readOnly /> {option.name}
                                </DropdownItem>
                            ))}
                        </>
                    ) : (
                        <div className="px-2 py-2 text-center text-muted">
                            No data available
                        </div>
                    )}
                </DropdownMenu>
            </ButtonDropdown>
        </div>
    );
};

export default MinimalMultiSelect;



// WEBPACK FOOTER //
// ./src/components/common/MinimalMultiSelect.tsx